import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import SalonServicesEditor from './SalonServicesEditor';

/**
 * Resolves a serviceRequests/{requestId} doc to its target salon, then
 * renders the shared SalonServicesEditor in "prepare for review" mode
 * (requestId/requestType props make it write to profile.pendingServicesData
 * and advance the request instead of publishing directly).
 */
function ServiceRequestEditor() {
  const { requestId } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setLoadError('');
        const snap = await getDoc(doc(db, 'serviceRequests', requestId));
        if (cancelled) return;
        if (!snap.exists()) {
          setLoadError('Service request not found');
          return;
        }
        setRequest({ id: snap.id, ...snap.data() });
      } catch (err) {
        if (!cancelled) setLoadError('Failed to load. Please try again.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [requestId]);

  if (loading) {
    return (
      <div className="salon-services-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading service request...</p>
        </div>
      </div>
    );
  }

  if (loadError || !request) {
    return (
      <div className="salon-services-page">
        <div className="error-container">
          <p className="error-text">{loadError || 'Service request not found'}</p>
          <button className="retry-btn" onClick={() => navigate('/service-requests')}>
            Back to Requests
          </button>
        </div>
      </div>
    );
  }

  return (
    <SalonServicesEditor
      salonId={request.salonId}
      salonName={request.salonName}
      requestId={request.id}
      requestType={request.type}
    />
  );
}

export default ServiceRequestEditor;
